// In-memory CSRF token store. Set by /auth/login, /auth/refresh,
// /auth/magic-link/consume; consumed by the apiClient middleware on
// every mutating request. Never persisted to localStorage (XSS-safe);
// lost on hard reload — a /auth/me + refresh round-trip restores it.
let _csrfToken: string | null = null;

export const csrf = {
  set(token: string) {
    _csrfToken = token;
  },
  get(): string | null {
    return _csrfToken;
  },
  clear() {
    _csrfToken = null;
  },
};
